import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { withI18n } from 'spa/Components/Context';

import Radio from '@urbanmassage/component-library/lib/Radio/Radio';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';
import StatusLabel, { LabelColorThemes } from '@urbanmassage/component-library/lib/Labels/StatusLabel/StatusLabel';

import './gifts-card-upgrade.less';

const UPGRADE_OPTIONS = require('./gifts-upgrade-options.json');

const GiftCardUpgrade = ({
  selectedCity,
  giftTreatment,
  currencySymbol,
  handleGiftUpgrade,
  giftUpgrade,
  giftUpgradeInvalid,
  tracker,
  setHasGiftUpgradeOptions,
}, { i18n }) => {
  const [list, setList] = React.useState([]);
  const [options, setOptions] = React.useState([]);

  const formatOption = (option) => {
    return (
      <div className="gifts-upgrade__option-item-inner">
        <span className="gifts-upgrade__option-item-text">
          {`${option.description} (+${currencySymbol}${option.upgrade_value})`}
        </span>
        {option.isPopular &&
          <div className="gifts-upgrade__options-item-poular-wrapper">
            <StatusLabel
              text={i18n._x('Popular', 'Gifts page')}
              theme={LabelColorThemes.success}
              fontSize="small"
            />
          </div>
        }
      </div>
    );
  };

  const handleChange = (event) => {
    const { value } = event.target;
    const option = options.find(item => item.option_id === value);
    if (!option) {
      handleGiftUpgrade(null);
      tracker.track('Dismissed Gift A Treatment Upsell Option', {
        category: 'Gifts',
      });
      return;
    }
    handleGiftUpgrade(option);
    tracker.track('Selected Gift A Treatment Upsell Option', {
      category: 'Gifts',
      data: {
        option_id: option.option_id,
        option_description: option.description,
        option_price: option.upgrade_value,
      },
    });
  };

  useEffect(() => {
    if (selectedCity) {
      if (!UPGRADE_OPTIONS[selectedCity].length) {
        setList([]);
        setOptions([]);
        return;
      }
      setList(UPGRADE_OPTIONS[selectedCity]);
    }
  }, [selectedCity]);

  useEffect(() => {
    if (list.length && giftTreatment && giftTreatment.specialityId) {
      const optionsList = list.find(item => item.speciality_id === Number(giftTreatment.specialityId));

      if (!optionsList) {
        setOptions([]);
        setHasGiftUpgradeOptions(false);
        return;
      }
      setHasGiftUpgradeOptions(true);
      setOptions(optionsList.options);
    }
  }, [list, giftTreatment]);

  const isChecked = (option) => {
    return giftUpgrade && giftUpgrade.option_id === option.option_id;
  };

  if (!options.length) {
    return null;
  }

  return (
    <div className="gifts-upgrade__wrapper" data-testid="gifts-upgrade-wrapper">
      <Typography className="gifts-upgrade__title" variant={TypeVariants.h3} fontFamily="heading" data-testid="gifts-upgrade-title">
        {i18n._x('Treat them to longer', 'Gifts page')}
      </Typography>
      <Typography className="gifts-upgrade__subtitle" variant={TypeVariants.body} data-testid="gifts-upgrade-subtitle">
        {i18n._x('Add a little more time on the table to make it extra special.', 'Gifts page')}
      </Typography>
      <div className="gifts-upgrade__options" data-testid="gifts-upgrade-options">
        {options.map(option => (
          <div className="gifts-upgrade__options-item" key={option.option_id} data-testid="gifts-upgrade-options-item">
            <Radio
              label={formatOption(option)}
              name="upgrade-experience"
              onChange={handleChange}
              value={option.option_id}
              checked={isChecked(option)}
              valid={!giftUpgradeInvalid}
            />
          </div>
        ))}
        <div className="gifts-upgrade__options-item" data-testid="gifts-upgrade-options-item">
          <Radio
            label={
              <div className="gifts-upgrade__option-item-inner">
                <span className="gifts-upgrade__option-item-text">
                  {i18n._x('Not this time, thanks', 'Gifts page')}
                </span>
              </div>
            }
            name="upgrade-experience"
            onChange={handleChange}
            value={0}
            valid={!giftUpgradeInvalid}
            checked={giftUpgrade !== undefined && giftUpgrade === null}
          />
        </div>
      </div>
    </div>
  );
};

GiftCardUpgrade.propTypes = {
  giftUpgrade: PropTypes.shape({
    description: PropTypes.string,
    isPopular: PropTypes.bool,
    option_id: PropTypes.string,
    upgrade_value: PropTypes.number,
  }),
  handleGiftUpgrade: PropTypes.func.isRequired,
  giftUpgradeInvalid: PropTypes.bool,
  currencySymbol: PropTypes.string,
  selectedCity: PropTypes.string,
  giftTreatment: PropTypes.shape({
    groupIndex: PropTypes.string,
    specialityId: PropTypes.string,
    value: PropTypes.string,
  }),
  setHasGiftUpgradeOptions: PropTypes.func.isRequired,
  tracker: PropTypes.shape({
    track: PropTypes.func.isRequired,
  }),
};

GiftCardUpgrade.defaultProps = {
  currencySymbol: '',
  selectedCity: '',
  giftTreatment: {
    groupIndex: '',
    specialityId: '',
    value: '',
  },
};

export default inject(({
  store: {
    tracker,
  },
}) => ({
  tracker,
}))(withI18n(GiftCardUpgrade));



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftCardUpgrade.jsx